import { RxStompConfig } from '@stomp/rx-stomp';

export const stompConfig: RxStompConfig = {

	// les placeholder seront remplacés au runtime. cf : stomp.service.ts
	// Which server?
	brokerURL: 'ws://placeholder:placeholder/ws',

	// Headers
	// Typical keys: login, passcode, host
	connectHeaders: {
		login: 'placeholder',
		passcode: 'placeholder',
	},

	// How often to heartbeat?
	// Interval in milliseconds, set to 0 to disable
	heartbeatIncoming: 0, // Typical value 0 - disabled
	heartbeatOutgoing: 30000, // Typical value 20000 - every 20 seconds

	// Wait in milliseconds before attempting auto reconnect
	// Set to 0 to disable
	// Typical value 500 (500 milli seconds)
	reconnectDelay: 1000,

	// Will log diagnostics on console
	// It can be quite verbose, not recommended in production
	// Skip this key to stop logging to console
	debug: (msg: string): void => {
		console.log(new Date(), msg);
	},
};
